import React from 'react';

import { TypographyTable } from '../index';

const bodyValuesRefreshed = [
	{
		previewText: 'Aa',
		tokenName: 'font.body.large',
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		paragraphSpacing: '16px',
	},
	{
		previewText: 'Aa',
		tokenName: 'font.body',
		fontSize: '14px',
		lineHeight: '20px',
		fontWeight: 400,
		paragraphSpacing: '12px',
	},
	{
		previewText: 'Aa',
		tokenName: 'font.body.small',
		fontSize: '12px',
		lineHeight: '16px',
		fontWeight: 400,
		paragraphSpacing: '8px',
	},
];

/**
 * __Typography body table__
 */
export const TypographyBodyTable = (): React.JSX.Element => {
	return (
		<TypographyTable
			values={bodyValuesRefreshed}
			hasParagraphSpacing
			testId="typography-body-table-modernized"
		/>
	);
};
